/*
  RRYT DRIP — "come back" tab title.
  When the visitor switches away from this tab, cycle an attention-grabbing
  title every 0.5s. When they return, restore the original page title.
  Uses the Page Visibility API so it only fires on a real tab switch / minimise.
*/
(function () {
  var original = document.title;
  // Cycled every 0.5s while the tab is hidden. Double-quoted so apostrophes are safe.
  var messages = [
    "Still Thinking? 😏",
    "Your Drip's Waiting ❤️🖤",
    "Don't Miss the Heat 🔥"
  ];
  var i = 0;
  var timer = null;

  function start() {
    if (timer) return;
    document.title = messages[0];
    i = 1;
    timer = setInterval(function () {
      document.title = messages[i % messages.length];
      i++;
    }, 500);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    document.title = original;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      start();
    } else {
      stop();
    }
  });
})();
